import 'urlpattern-polyfill'
import routerState from './store.js'
import { html, unsafeStatic } from 'lit/static-html.js'
import HHQuizElement from '../element.js'

/**
 * Router element
 * renders the current route
 * @extends
 * @extends observeState
 * @customElement
 *
 * @example
 * <quiz-router />
 *
 */
export default class HHQuizRouterElement extends HHQuizElement {
  /**
   * Handles hash change
   * - Updates the router path
   * - Implements before() hook guard
   *
   * @TODO implement delay to allow transitions
   */
  handleHashChange = () => {
    if (this.store.isStatic) return
    const newPath =
      (window.location.hash.includes('#')
        ? window.location.hash.split('#')[1]
        : window.location.hash) || '/'

    const route = routerState.matchAndHydrateRoute(newPath)

    const { before = (h) => h } = route || {}

    const path = before(newPath, route);

    this.dispatchEvent(
      new CustomEvent('before-route', {
        detail: { path },
        bubbles: true,
        composed: true,
      })
    )

    window.scrollTo(0, 0)
    
    routerState.path = path
    window.location.hash = path
  }

  /**
   * Adds hash change listener
   * Updates the router path
   */
  connectedCallback() {
    super.connectedCallback()
    this.handleHashChange()
    window.addEventListener('hashchange', this.handleHashChange)
  }

  /**
   * Removes hash change listener
   */
  disconnectedCallback() {
    window.removeEventListener('hashchange', this.handleHashChange)
    super.disconnectedCallback()
  }

  /**
   * Renders the current route view
   * @returns {TemplateResult}
   */
  renderRoute = () => {
    if (!routerState.current?.component)
      return routerState.current?.render(routerState.current.params)

    const view =
      typeof routerState.current.component == 'function'
        ? routerState.current.component(routerState.current.params)
        : routerState.current.component

    return html`<${unsafeStatic(view)}><slot /></${unsafeStatic(view)}>`
  }

   /**
   * Router view is ready
   */
  updated() {
    this.router.isReady = true
  }
}
